/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MatchboardService {
    /**
     * Get Match Board Match
     * @param matchId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getMatchBoardMatchMatchBoardMatchMatchIdGet(
        matchId: number,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/match_board/match/{match_id}',
            path: {
                'match_id': matchId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Update Match Board
     * @param matchId
     * @param matchBoardId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static updateMatchBoardMatchBoardMatchMatchIdPost(
        matchId: number,
        matchBoardId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/match_board/match/{match_id}',
            path: {
                'match_id': matchId,
            },
            query: {
                'match_board_id': matchBoardId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
